module.exports = __webpack_public_path__ + "img/chinesecompany198.51534b7b.png";